export const categories = [
  {
    id: 'shoes',
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20designer%20sneakers%20arranged%20on%20warm%20beige%20linen%20fabric%20surface%20soft%20morning%20window%20light%20casting%20gentle%20shadows%20contemporary%20athletic%20footwear%20with%20premium%20leather%20texture%20editorial%20fashion%20catalog%20style%20sophisticated%20neutral%20palette%20with%20subtle%20terracotta%20accents&width=800&height=1000&seq=cat-shoes-v2&orientation=portrait',
    description: 'Trending sneakers, boots & athletic footwear',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20heavyweight%20cotton%20hoodie%20draped%20elegantly%20on%20rustic%20wooden%20surface%20warm%20ambient%20light%20from%20side%20window%20creating%20depth%20soft%20earth%20tone%20color%20palette%20relaxed%20streetwear%20aesthetic%20editorial%20fashion%20photography%20natural%20fabric%20folds%20and%20texture%20details%20visible&width=800&height=1000&seq=cat-hoodies-v2&orientation=portrait',
    description: 'Cozy hoodies, crewnecks & knit sweaters',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20cotton%20t-shirt%20neatly%20folded%20on%20light%20oak%20wooden%20table%20surface%20afternoon%20sunlight%20streaming%20through%20sheer%20curtains%20creating%20soft%20highlights%20modern%20essential%20wardrobe%20piece%20clean%20Scandinavian%20aesthetic%20editorial%20product%20photography%20warm%20ivory%20tones&width=800&height=1000&seq=cat-tshirts-v2&orientation=portrait',
    description: 'Essential tees, graphic prints & basics',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Contemporary%20olive%20green%20bomber%20jacket%20styled%20on%20minimalist%20wooden%20hanger%20against%20textured%20off-white%20wall%20gentle%20afternoon%20light%20from%20nearby%20window%20casting%20soft%20shadows%20modern%20outerwear%20design%20with%20subtle%20sheen%20fabric%20editorial%20fashion%20catalog%20style%20warm%20earthy%20color%20scheme&width=800&height=1000&seq=cat-jackets-v2&orientation=portrait',
    description: 'Bombers, denim jackets & outerwear',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20relaxed%20fit%20cargo%20pants%20flat%20laid%20on%20light%20stone%20colored%20linen%20backdrop%20diffused%20natural%20daylight%20creating%20even%20illumination%20casual%20contemporary%20streetwear%20style%20visible%20pocket%20details%20and%20drawstring%20accents%20warm%20sandy%20neutral%20tones%20editorial%20product%20photography&width=800&height=1000&seq=cat-pants-v2&orientation=portrait',
    description: 'Cargo pants, jeans, shorts & joggers',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trendy%20unstructured%20baseball%20cap%20placed%20on%20light%20terracotta%20ceramic%20surface%20side%20window%20natural%20light%20creating%20subtle%20curved%20shadows%20modern%20streetwear%20accessory%20with%20embroidered%20detail%20warm%20neutral%20earth%20tone%20palette%20minimalist%20editorial%20style%20lifestyle%20product%20photography&width=800&height=1000&seq=cat-headwear-v2&orientation=portrait',
    description: 'Caps, beanies, bucket hats & more',
  },
  {
    id: 'sets',
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20two-piece%20lounge%20set%20elegantly%20arranged%20on%20warm%20sand%20colored%20textile%20surface%20soft%20diffused%20daylight%20from%20large%20window%20contemporary%20loungewear%20fashion%20relaxed%20silhouette%20matching%20top%20and%20bottom%20ensemble%20natural%20oatmeal%20and%20ivory%20tone%20palette%20editorial%20lifestyle%20product%20photography&width=800&height=1000&seq=cat-sets-v2&orientation=portrait',
    description: 'Coordinated 2-piece & 3-piece sets',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20organic%20cotton%20underwear%20basics%20neatly%20arranged%20on%20light%20bamboo%20textured%20surface%20gentle%20morning%20light%20from%20frosted%20window%20creating%20soft%20atmosphere%20essential%20wardrobe%20foundations%20minimal%20aesthetic%20warm%20ivory%20and%20sand%20color%20palette%20clean%20editorial%20product%20photography&width=800&height=1000&seq=cat-underwear-v2&orientation=portrait',
    description: 'Essential underwear, boxers & briefs',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20displayed%20flat%20on%20light%20grey%20concrete%20surface%20dramatic%20side%20lighting%20creating%20bold%20shadows%20modern%20athletic%20wear%20design%20with%20vibrant%20color%20accents%20performance%20fabric%20texture%20visible%20editorial%20sports%20fashion%20photography%20dynamic%20composition&width=800&height=1000&seq=cat-jersey-v2&orientation=portrait',
    description: 'Sports jerseys, football & basketball kits',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20minimalist%20fashion%20accessories%20including%20watch%20bracelet%20and%20sunglasses%20arranged%20on%20warm%20marble%20surface%20afternoon%20golden%20hour%20light%20creating%20elegant%20reflections%20sophisticated%20lifestyle%20aesthetic%20neutral%20taupe%20and%20champagne%20tones%20editorial%20still%20life%20photography&width=800&height=1000&seq=cat-accessories-v2&orientation=portrait',
    description: 'Watches, jewelry, sunglasses & more',
  },
  {
    id: 'bags',
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20minimalist%20canvas%20backpack%20leaning%20against%20light%20birch%20wood%20surface%20soft%20window%20light%20from%20left%20side%20contemporary%20everyday%20carry%20design%20with%20leather%20trim%20details%20warm%20sand%20and%20olive%20tone%20palette%20editorial%20product%20photography%20clean%20composition&width=800&height=1000&seq=cat-bags-v2&orientation=portrait',
    description: 'Backpacks, handbags, crossbody & totes',
  },
  {
    id: 'belts',
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Handcrafted%20genuine%20leather%20belt%20coiled%20elegantly%20on%20warm%20chestnut%20wood%20surface%20natural%20daylight%20from%20window%20revealing%20rich%20brown%20tones%20and%20subtle%20grain%20texture%20classic%20accessory%20design%20with%20polished%20metal%20buckle%20editorial%20still%20life%20photography%20timeless%20aesthetic&width=800&height=1000&seq=cat-belts-v2&orientation=portrait',
    description: 'Leather belts, casual belts & designer styles',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20amber%20glass%20perfume%20bottle%20with%20minimalist%20label%20placed%20on%20light%20travertine%20stone%20surface%20soft%20diffused%20morning%20light%20creating%20delicate%20reflections%20luxury%20fragrance%20product%20sophisticated%20warm%20golden%20and%20sand%20tone%20palette%20editorial%20beauty%20photography%20refined%20composition&width=800&height=1000&seq=cat-perfumes-v2&orientation=portrait',
    description: 'Designer fragrances, colognes & scents',
  },
  {
    id: 'otherstuff',
    name: 'OtherStuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Diverse%20collection%20of%20trendy%20lifestyle%20gadgets%20and%20small%20accessories%20arranged%20artistically%20on%20light%20oatmeal%20linen%20fabric%20background%20soft%20natural%20window%20illumination%20contemporary%20everyday%20carry%20items%20warm%20neutral%20earthy%20tones%20editorial%20flat%20lay%20product%20photography%20harmonious%20composition&width=800&height=1000&seq=cat-otherstuff-v2&orientation=portrait',
    description: 'Miscellaneous items, gadgets & lifestyle products',
  },
];

export const categoryLabels: Record<string, string> = {
  shoes: 'Shoes',
  hoodies: 'Hoodies/Sweaters',
  tshirts: 'T-Shirts',
  jackets: 'Jackets',
  pants: 'Pants/Shorts',
  headwear: 'Headwear',
  sets: 'Sets',
  underwear: 'Underwear/Underpants',
  jersey: 'Jersey',
  accessories: 'Accessories',
  bags: 'Bags',
  belts: 'Belts',
  perfumes: 'Perfumes',
  otherstuff: 'OtherStuff',
};